import {
	Button,
	DropdownMenu,
	ItemRowCheckbox,
	ItemRowHeader,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { CustomCheckbox } from '@ukpostbox/frontend-framework/lib/Components/Forms/Toggle/ToggleSwitchCustom';
import { ItemRowHeaderCell } from '@ukpostbox/frontend-framework/lib/Components/ItemRow/Cells/ItemRowHeaderCell';
import { ItemRowAddon } from '@ukpostbox/frontend-framework/lib/Components/ItemRow/ItemRowAddon';
import React from 'react';
import { MailboxGridSize } from '../../Toolbars/Controls/MailboxGridSize';
import SelectionBar from '../../../../_Global/Components/SelectionBar';
import { SelectedMailToolbar } from '../../Toolbars/SelectedMailToolbar';
import { MailboxesSelectedMenu } from '../../Menus/MailboxesSelectedMenu';
import { MailboxListHeaderType } from '../../Types/MailboxTypes';

function MailboxListHeader({
	mailBoxInfo,
	status,
	resetSelectionCallback,
	data,
	gridView,
	selectedItems,
	visibleSelected,
	visibleIndeterminate,
	toggleVisibleCallback,
	allSelected,
}: MailboxListHeaderType) {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium, isLarge } = useLayout();

	return (
		<ItemRowHeader
			title='Mailbox List Header'
			extraClass={`mailbox-item-row-header ${selectedItems.length > 0 || gridView ? 'item-row-actions-active' : ''}`}
			sticky
		>
			<ItemRowCheckbox>
				<CustomCheckbox
					name='mailItem-all'
					label='mailItem-all'
					defaultChecked={allSelected || (!visibleIndeterminate && visibleSelected)}
					isIndeterminate={!allSelected && visibleIndeterminate}
					onChange={(e) => toggleVisibleCallback(data, 'mailUuid', !visibleSelected)}
					hideLabel
				/>
			</ItemRowCheckbox>

			{selectedItems.length === 0 && !gridView && (
				<>
					<ItemRowHeaderCell>{t('mailboxes.headings.envelope')}</ItemRowHeaderCell>
					{!isTiny && <ItemRowHeaderCell>{t('mailboxes.headings.content')}</ItemRowHeaderCell>}
					<ItemRowHeaderCell>{t('mailboxes.headings.reference')}</ItemRowHeaderCell>
					{!isTiny && !isSmall && (
						<ItemRowHeaderCell>
							{mailBoxInfo.folderSlug === 'pending'
								? t('mailboxes.headings.actionPending')
								: t('mailboxes.headings.pages')}
						</ItemRowHeaderCell>
					)}
					{!isTiny && !isSmall && !isMedium && !isLarge && (
						<ItemRowHeaderCell>{t('mailboxes.headings.trackingIds')}</ItemRowHeaderCell>
					)}
					{!isTiny && !isSmall && !isMedium && (
						<ItemRowHeaderCell>{t('mailboxes.headings.tags')}</ItemRowHeaderCell>
					)}
					{!isTiny && !isSmall && !isMedium && !isLarge && (
						<ItemRowHeaderCell>{t('mailboxes.headings.notes')}</ItemRowHeaderCell>
					)}
				</>
			)}

			{selectedItems.length === 0 && gridView && (
				<ItemRowAddon extraClass='ml-a'>
					<MailboxGridSize />
				</ItemRowAddon>
			)}

			{status === 'success' && selectedItems.length > 0 && (
				<ItemRowAddon>
					<SelectionBar
						selectedIds={selectedItems}
						clearSelectionCallback={() => resetSelectionCallback()}
						iconsOnly
					>
						{!isTiny && !isSmall && !isMedium && (
							<SelectedMailToolbar
								data={data}
								showCustomFolderRemove={!!mailBoxInfo.customFolderId && mailBoxInfo.customFolderId > -1}
							/>
						)}

						{(isTiny || isSmall || isMedium) && (
							<DropdownMenu
								title='Mailbox Actions Dropdown'
								trigger={
									<Button
										title={t('mailboxes.mailActions.title')}
										showArrow
										squared
										extraClass='mail-actions-menu mr-xs'
									/>
								}
							>
								<MailboxesSelectedMenu
									data={data}
									showCustomFolderRemove={
										!!mailBoxInfo.customFolderId && mailBoxInfo.customFolderId > -1
									}
								/>
							</DropdownMenu>
						)}
					</SelectionBar>
				</ItemRowAddon>
			)}
		</ItemRowHeader>
	);
}

export { MailboxListHeader };
